import DefaultModal from "../default_modal";
import { SimpleDefaultModal, ModalContent } from './styles';
import React, { useState } from 'react';
import { StyledButton } from "../default_button/styles";
import CurrentNotifications from '../current_notifitcations';
import { notificationService } from '../../services/notificationService';

const KanbanSendNotificationModal = ({ isOpen, onClose, onConfirmNotification, notification, currentOwnerID, notificationID, children }) => {
  const [showNotificationMessage, setShowNotificationMessage] = useState(false);

  const sendNotificationNow = async () => {
    try {
      // 🔹 Atualiza token Expo
      const updateResponse = await notificationService.updateExpoPushToken(
        currentOwnerID,
        "ExponentPushToken[ebpVLBJTGyx0B3U8pbCmUL]"
      );

      // 🔹 Se der certo, envia notificação
      if (updateResponse) {
        const notificationResponse = await notificationService.sendNotification(
          currentOwnerID,
          notificationID
        );
        console.log("✅ Notificação enviada:", notificationResponse);
      } else {
        throw new Error('Atualização de token falhou');
      }
    } catch (error) {
      console.error('❌ Erro ao enviar notificação:', error);
    }
  };

  const handleContentClick = (event) => {
    event.stopPropagation();
  };

  const handleConfirmNotification = () => {
    onConfirmNotification();
    onClose();
    sendNotificationNow();
  };

  const handleCancelNotification = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <DefaultModal isOpen={isOpen} onClose={onClose}>
      <SimpleDefaultModal onClick={onClose}>
        <ModalContent style={{ width: '350px' }}>
          <h4>Deseja notificar o usuário de seu novo status?</h4>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around' }}>
            <StyledButton onClick={handleConfirmNotification} style={{ width: '128px' }}>Sim</StyledButton>
            <StyledButton onClick={handleCancelNotification} style={{ width: '128px' }}>Não</StyledButton>
          </div>
          <div
            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', marginTop: '32px', marginBottom: '32px' }}
            onClick={handleContentClick} // Handle click event for the modal content area
          >
            <span style={{ color: 'var(--info)', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setShowNotificationMessage(!showNotificationMessage)}>
              {showNotificationMessage ? "Colapsar notificações" : "Visualizar notificações"}
            </span>
          </div>
          {showNotificationMessage && <CurrentNotifications />}
        </ModalContent>
      </SimpleDefaultModal>
    </DefaultModal>
  );
};

export default KanbanSendNotificationModal;
